<template>
    <div class="main-container">
        <v-container fluid class="edit-panel overflow-auto pa-5">
            <h4 class="mb-2">{{ $t('veranstaltungsart') }}</h4>
            <span v-html="$t('veranstaltungsart_erfassen_info')" />
            <v-row class="mt-4">
                <template v-for="eventClass in eventClasses.models">
                    <v-col v-if="!eventClass.staffOnly || userIsStaff()" :key="eventClass.value" cols="12" lg="6">
                        <v-btn
                            :color="record.event_class === eventClass.classValue ? 'primary' : null"
                            width="100%"
                            depressed
                            @click="onInput('event_class', eventClass.classValue)"
                        >
                            {{ eventClass.label }}
                        </v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-container>
        <div class="info-panel overflow-auto pa-5">
            <template v-for="eventClass in eventClasses.models">
                <KpAlert
                    v-if="eventClass.description && record.event_class === eventClass.classValue"
                    :key="eventClass.value"
                    type="info"
                    style="max-width: 600px"
                >
                    <span v-html="eventClass.description" />
                </KpAlert>
            </template>
        </div>
    </div>
</template>

<script>
import { Event } from '@/models/Event';
import { mapState } from 'vuex';
import { userIsStaff } from '@/helpers/auth';
import { getEventClasses } from '@/models/EventClass';

export default {
    name: 'EventEditEventClass',

    props: {
        record: {
            type: Event,
            required: true,
        },
    },

    data() {
        return {
            Event,
        };
    },
    computed: {
        ...mapState('user', {
            authUser: 'record',
        }),
    },
    created() {
        this.userIsStaff = userIsStaff;
        this.eventClasses = getEventClasses();
    },

    mounted() {
        this.$emit('input', true);
    },

    methods: {
        onInput(field, value) {
            if (this.record.userCanSave(this.authUser)) {
                this.record.set(field, value);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    display: grid;
    grid-template-areas: 'edit info';
    grid-template-rows: auto;
    grid-template-columns: minmax(400px, 600px) minmax(300px, 1fr);
    overflow: auto;
}
.edit-panel {
    grid-area: edit;
}
.info-panel {
    grid-area: info;
    background-color: var(--toolbar-bg-color);
}
</style>
